(function () {
  var desktopQuery = window.matchMedia('(min-width: 1068px)');
  var defaultRailColor = '#E92588';

  function getMenuParts() {
    return {
      nav: document.querySelector('[data-header-tabs]'),
      column: document.querySelector('.header-tabs-navigation__column'),
      root: document.querySelector('[data-sidebar-flyout-root]'),
      backdrop: document.querySelector('[data-sidebar-flyout-backdrop]')
    };
  }

  function isInsideMenu(target, parts) {
    return !!(
      target &&
      ((parts.nav && parts.nav.contains(target)) ||
        (parts.column && parts.column.contains(target)) ||
        (parts.root && parts.root.contains(target)))
    );
  }

  function clearActiveTab() {
    var parts = getMenuParts();
    if (!parts.nav) return;

    parts.nav.querySelectorAll('li[data-tab-index]').forEach(function (item) {
      item.classList.remove('is-active');
      var button = item.querySelector('[data-tab-select]');
      if (!button) return;
      button.removeAttribute('aria-current');
      button.setAttribute('aria-selected', 'false');
    });

    document.querySelectorAll('.header-tabs-navigation__column').forEach(function (column) {
      column.style.setProperty('--header-tabs-rail', defaultRailColor);
    });
    document.documentElement.style.removeProperty('--header-tab-accent');
  }

  function closeFlyout() {
    var parts = getMenuParts();

    clearActiveTab();

    if (parts.root) {
      parts.root.setAttribute('hidden', '');
      parts.root.setAttribute('aria-hidden', 'true');
    }

    document.documentElement.classList.remove('sidebar-flyout-open');
    document.documentElement.style.removeProperty('--flyout-chrome-bottom');
  }

  function clearIfPointerLeftMenu(event) {
    if (!desktopQuery.matches) return;

    var parts = getMenuParts();
    if (isInsideMenu(event.relatedTarget, parts)) return;

    window.setTimeout(function () {
      var hoveredMenu = document.querySelector(
        '.header-tabs-navigation__column:hover, [data-sidebar-flyout-root]:hover'
      );
      if (!hoveredMenu) clearActiveTab();
    }, 80);
  }

  function bind() {
    var parts = getMenuParts();
    if (!parts.nav || parts.nav.getAttribute('data-hover-reset-bound') === 'true') return;

    parts.nav.setAttribute('data-hover-reset-bound', 'true');

    if (parts.column) {
      parts.column.addEventListener('mouseleave', clearIfPointerLeftMenu);
    }
    if (parts.root) {
      parts.root.addEventListener('mouseleave', clearIfPointerLeftMenu);
    }
    if (parts.backdrop) {
      parts.backdrop.addEventListener('mouseenter', clearActiveTab);
      parts.backdrop.addEventListener('click', closeFlyout);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
